import { defineMessages } from 'react-intl';

import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const messages = defineMessages({
  align: {
    id: 'Align',
    defaultMessage: 'Align',
  },
});
export const alignStyleSchema = ({ schema, formData, intl }) => {
  addStyling({ schema, intl });

  schema.properties.styles.schema.fieldsets[0].fields = [
    ...schema.properties.styles.schema.fieldsets[0].fields,
    'align',
  ];
  schema.properties.styles.schema.properties.align = {
    title: intl.formatMessage(messages.align),
    widget: 'align',
    default: 'left',
    actionsInfoMap: { 'text-left': [] },
  };
  schema.properties.styles.schema.properties.align.actions = ['center', 'full'];

  return schema;
};
